import React, { useEffect, useState } from 'react';
import { Clock, Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';
import {
  formatSoiDaoCountdown,
  roundStatusLabel,
  tickRemainingTime,
} from '../../utils/soiDaoUtils';

export function SoiDaoRoundHeader({ room, round, remainingTime }) {
  const [displayTime, setDisplayTime] = useState(remainingTime);

  useEffect(() => {
    setDisplayTime(remainingTime);
  }, [remainingTime]);

  useEffect(() => {
    if (!displayTime || displayTime.isExpired) return undefined;
    const timer = setInterval(() => {
      setDisplayTime((prev) => tickRemainingTime(prev));
    }, 1000);
    return () => clearInterval(timer);
  }, [displayTime]);

  if (!room) return null;

  const entryCount = round?.entryCount ?? 0;

  return (
    <Card className="border-2 border-brand-gold/40 bg-gradient-to-br from-white to-brand-gold-light/20">
      <CardHeader className="border-brand-gold/20 bg-brand-red/5">
        <CardTitle className="flex items-center gap-2 text-brand-red">
          <Star className="h-5 w-5 fill-brand-gold text-brand-gold" />
          {room.name}
        </CardTitle>
        <p className="text-sm text-gray-600">
          เลือกตำแหน่งดาวบนกระดาน · ราคา {formatMoney(room.price)} ต่อดาว
        </p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          <div className="rounded-xl border border-red-100 bg-white p-3 text-center">
            <p className="text-xs text-gray-500">รอบปัจจุบัน</p>
            <p className="text-xl font-bold text-brand-red">
              #{round?.roundNumber || '-'}
            </p>
          </div>
          <div className="rounded-xl border border-brand-gold/50 bg-brand-gold-light/30 p-3 text-center">
            <p className="text-xs text-gray-500">สถานะ</p>
            <p className="text-sm font-bold text-brand-gold">
              {roundStatusLabel(round?.status)}
            </p>
          </div>
          <div className="rounded-xl border border-red-100 bg-white p-3 text-center">
            <p className="text-xs text-gray-500">ดาวที่ซื้อแล้ว</p>
            <p className="text-xl font-bold text-brand-red">{entryCount}</p>
            <p className="text-[10px] text-gray-400">เปิดเลขผลทันที</p>
          </div>
          <div className="rounded-xl border border-red-100 bg-white p-3 text-center">
            <p className="flex items-center justify-center gap-1 text-xs text-gray-500">
              <Clock className="h-3 w-3" />
              ปิดรอบใน
            </p>
            <p className="font-mono text-xl font-bold text-brand-red">
              {formatSoiDaoCountdown(displayTime)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
